module.exports = __webpack_public_path__ + "img/sign_apply_next.96d552d2.png";